module.exports = __webpack_public_path__ + "img/blue-downArrow.49300f1b.svg";